import React from "react";
import "./tour-preview.styles.scss";

const TourPreview = ({ propertyPreviewUrl, selectedPropertyName }) => {
  return (
    <div
      className="tour-preview"
      style={{
        backgroundImage: `url(${propertyPreviewUrl})`,
      }}
    >
      {selectedPropertyName ? (
        <span className="tour-preview-property-name">
          {selectedPropertyName}
        </span>
      ) : (
        <span className="tour-preview-unselected">
          Please wait while the host selects your property
        </span>
      )}
    </div>
  );
};

export default TourPreview;
